import { render, staticRenderFns } from "./CommentSort.vue?vue&type=template&id=f5c52432&"
import script from "./CommentSort.vue?vue&type=script&lang=js&"
export * from "./CommentSort.vue?vue&type=script&lang=js&"
import style0 from "./CommentSort.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports